import { Column, GridContainer, Row } from '@vp/swan';
import { FindOrder } from './FindOrder';
import { ShopperProfile } from './ShopperProfile';

interface HistoryViewHeaderProps {
  showSearchBar: boolean;
}

export const HistoryViewHeader = ({
  showSearchBar,
}: HistoryViewHeaderProps) => (
  <GridContainer>
    <Row>
      {/* Shopper profile info */}
      <Column span={8}>
        <ShopperProfile />
      </Column>
      {/* Order search */}
      {showSearchBar ? (
        <Column span={4} pt={5}>
          <FindOrder />
        </Column>
      ) : null}
    </Row>
  </GridContainer>
);
